/* import __COLOCATED_TEMPLATE__ from './segmentation-settings-drawer.hbs'; */
/* RESPONSIBLE TEAM: team-conversational-knowledge */

import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type AiContentSegmentsService from 'embercom/services/ai-content-segments-service';

interface Args {
  isOpen: boolean;
  onClose: () => void;
}

export default class SegmentationSettingsDrawer extends Component<Args> {
  @service declare aiContentSegmentsService: AiContentSegmentsService;

  get showBrandWarning() {
    return (
      this.aiContentSegmentsService.hasLoadedSegments &&
      !this.aiContentSegmentsService.allAudiencesHaveBrandAttribute
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Suggestions::SegmentationSettingsDrawer': typeof SegmentationSettingsDrawer;
  }
}
